import { PUBLIC_ENV_VARS } from "./environment";

/**
 * Environment utility functions for cleaner environment-based logic.
 * Provides semantic functions instead of raw string comparisons.
 */
export class Env {
  /**
   * Check if we are in the production environment.
   * @returns true if in production environment with real data
   */
  static IsProduction(): boolean {
    return PUBLIC_ENV_VARS.ENVIRONMENT === "production";
  }

  /**
   * Check if we are in the staging environment.
   * @returns true if in staging environment with test data
   */
  static IsStaging(): boolean {
    return PUBLIC_ENV_VARS.ENVIRONMENT === "staging";
  }

  /**
   * Check if we are in a preview build environment.
   * @returns true if in preview build (like from a PR) with test data, settings mostly equal to staging
   */
  static IsPreview(): boolean {
    return PUBLIC_ENV_VARS.ENVIRONMENT === "preview";
  }

  /**
   * Check if we are in a local development environment.
   * @returns true if in local build with test data, settings mostly equal to staging
   */
  static IsDevelopment(): boolean {
    return PUBLIC_ENV_VARS.ENVIRONMENT === "development";
  }

  /**
   * Check if we are in any non-production environment.
   * @returns true if in staging, preview, development, or any other non-production environment
   */
  static IsNonProduction(): boolean {
    return !this.IsProduction();
  }

  /**
   * Get the current environment name.
   * @returns the current environment string value
   */
  static GetEnvironment(): string | undefined {
    return PUBLIC_ENV_VARS.ENVIRONMENT;
  }
}